import { documentApi, extractionApi } from '../api';

export function isPdfFile(file: File): boolean {
  return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
}

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

/**
 * Upload one drawing and return the document it created.
 *
 * The two ingest endpoints are mirror images of each other, and neither takes
 * both: `POST /upload` accepts images and answers 400 "Only image files are
 * allowed" to a PDF, while `POST /pnid-ai/upload` accepts PDFs — rasterising
 * them to 300dpi — and answers 400 "Only PDF files are allowed for AI
 * extraction" to an image. Routing on the file's own type is what lets one
 * control offer both, with no change to either endpoint.
 *
 * `jobId` comes back only for a PDF, which is the path that starts an
 * extraction worth polling.
 */
export async function uploadDrawing(file: File): Promise<{ docId: string; jobId?: string }> {
  if (isPdfFile(file)) {
    const result = await extractionApi.upload(file);
    return { docId: result.doc_id, jobId: result.job_id };
  }
  const result = await documentApi.upload(file);
  return { docId: result.doc_id };
}
